// utils/orders.js
// utils/orders.js
export function normalizeOrdersResponse(grouped) {
  if (!grouped || typeof grouped !== "object") return [];
  const out = [];
  for (const [vendorCode, items] of Object.entries(grouped)) {
    if (Array.isArray(items)) {
      for (const it of items) {
        out.push({ ...it, vendor: vendorCode }); // keep vendor code on the row
      }
    }
  }
  return out;
}
